const json = {
    encode: (json) => JSON.stringify(json),
    decode: (string) => JSON.parse(string),
}

export default {
    json,
}
